var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-list-view',{attrs:{"title":_vm.$store.state.Organization.OwnerType === 2
      ? 'Дочерние организации'
      : 'Головные организации',"dataSource":_vm.dataSource,"headers":_vm.headers,"loading":_vm.loading,"notShowActions":['delete', 'search', 'add'],"notShowSelect":"","showFilters":true},on:{"onRefresh":_vm.init}})
}
var staticRenderFns = []

export { render, staticRenderFns }